module.exports = __webpack_public_path__ + "static/sbfcu-0dd7f1654ce8d438bba6bd8214056c72.jpg";